import {GET_ALL_HR_DOCS} from "../../../enums/Request/request.types";

export const getUserHrDocsAction = (data) => {
    return {
        type: GET_ALL_HR_DOCS,
        payload:data,
    };
};
